var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microsoft_outlook_logo.svg",
    clipPath: "url(#clip0_44_213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.3466 16.8C34.3485 16.531 34.2097 16.2807 33.9808 16.14H33.9768L33.9624 16.132L22.0609 9.07601C22.0095 9.04124 21.9562 9.00945 21.9011 8.98082C21.4416 8.74337 20.8958 8.74337 20.4362 8.98082C20.3812 9.00947 20.3278 9.04124 20.2764 9.07601L8.37497 16.132L8.3606 16.14C7.99686 16.3666 7.88534 16.8456 8.11154 17.2099C8.17819 17.3172 8.26999 17.4066 8.37897 17.4704L20.2805 24.5264C20.332 24.5609 20.3854 24.5927 20.4402 24.6216C20.8998 24.8591 21.4456 24.8591 21.9052 24.6216C21.96 24.5927 22.0133 24.5609 22.0649 24.5264L33.9664 17.4704C34.2042 17.3316 34.3493 17.0757 34.3466 16.8Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.76243 12.0888H17.5727V19.2592H9.76243V12.0888ZM32.7491 4.8V1.51999C32.7679 0.699916 32.1198 0.0196509 31.301 0H11.0333C10.2145 0.0196509 9.56636 0.699916 9.58511 1.51999V4.8L21.5665 7.99999L32.7491 4.8Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.58511 4.79999H17.5727V12H9.58511V4.79999Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.5603 4.79999H17.5727V12L25.5603 19.2H32.7491V12L25.5603 4.79999Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.5727 12H25.5603V19.2H17.5727V12Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.5727 19.2H25.5603V26.3999H17.5727V19.2Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.76242 19.2592H17.5727V25.7775H9.76242V19.2592Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.5603 19.2H32.7491V26.3999H25.5603V19.2Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.9808 17.4264L33.9656 17.4344L22.0641 24.1384C22.0122 24.1704 21.9595 24.2008 21.9043 24.228C21.7022 24.3244 21.4827 24.3788 21.259 24.388L20.6088 24.0072C20.5538 23.9796 20.5005 23.9488 20.449 23.9152L8.38775 17.0208H8.38216L7.98758 16.8V30.3712C7.99373 31.2766 8.73137 32.0057 9.63541 32H32.7243C32.7379 32 32.7499 31.9936 32.7643 31.9936C32.9552 31.9813 33.1435 31.942 33.3234 31.8768C33.4012 31.8438 33.4762 31.8047 33.5479 31.76C33.6014 31.7296 33.6932 31.6632 33.6932 31.6632C34.1024 31.3599 34.3446 30.881 34.3466 30.3712V16.8C34.3463 17.0596 34.2066 17.2989 33.9808 17.4264Z",
    fill: "url(#paint0_linear_44_213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M33.7076 16.7464V17.5784L21.263 26.16L8.37899 17.0264C8.37899 17.022 8.37541 17.0184 8.371 17.0184L7.18884 16.3064V15.7064L7.67609 15.6984L8.70648 16.2904L8.73043 16.2984L8.81829 16.3544C8.81829 16.3544 20.9275 23.2744 20.9594 23.2904L21.4227 23.5624C21.4626 23.5463 21.5026 23.5304 21.5505 23.5144C21.5745 23.4983 33.5718 16.7384 33.5718 16.7384L33.7076 16.7464Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.9808 17.4264L33.9656 17.4352L22.0641 24.1392C22.0122 24.1712 21.9595 24.2016 21.9044 24.2288C21.4422 24.4549 20.9016 24.4549 20.4394 24.2288C20.3847 24.2016 20.3314 24.1717 20.2797 24.1392L8.3782 17.4352L8.36383 17.4264C8.13405 17.3016 7.98999 17.0618 7.98761 16.8V30.3712C7.99333 31.2765 8.73071 32.0057 9.63458 32C9.63458 32 9.63462 32 9.63465 32H32.6996C33.6035 32.0058 34.3409 31.2765 34.3467 30.3713C34.3467 30.3713 34.3467 30.3712 34.3467 30.3712V16.8C34.3464 17.0596 34.2066 17.2989 33.9808 17.4264Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.1,
    d: "M22.2375 24.04L22.0593 24.14C22.0077 24.1729 21.9544 24.2031 21.8996 24.2304C21.7033 24.3269 21.4899 24.3834 21.2718 24.3968L25.7999 29.76L33.6989 31.6664C33.9153 31.5026 34.0875 31.2873 34.1997 31.04L22.2375 24.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.05,
    d: "M23.0442 23.5856L22.0593 24.14C22.0077 24.1729 21.9544 24.2031 21.8996 24.2304C21.7033 24.3268 21.4899 24.3834 21.2718 24.3968L23.3933 30.2552L33.7012 31.664C34.1073 31.3586 34.3464 30.8797 34.3466 30.3711V30.1959L23.0442 23.5856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.65701 32H32.6972C33.0517 32.0018 33.3975 31.8896 33.6837 31.68L20.608 24.0088C20.553 23.9812 20.4997 23.9505 20.4482 23.9168L8.38698 17.0224H8.38139L7.98761 16.8V30.3248C7.98671 31.2491 8.73412 31.9991 9.65701 32Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.1,
    d: "M19.1702 7.86642V24.9304C19.1688 25.5287 18.8056 26.0665 18.2516 26.2904C18.08 26.3643 17.8952 26.4024 17.7085 26.4024H7.98758V7.20002H9.5851V6.40002H17.7085C18.5154 6.40309 19.1685 7.05822 19.1702 7.86642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.2,
    d: "M18.3715 8.66641V25.7304C18.3735 25.9236 18.3326 26.1149 18.2516 26.2904C18.0298 26.838 17.4998 27.1973 16.9097 27.2H7.98758V7.20002H16.9097C17.1415 7.19769 17.3699 7.25559 17.5727 7.36803C18.0623 7.61509 18.3713 8.1173 18.3715 8.66641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.2,
    d: "M18.3715 8.66641V24.1304C18.3676 24.9382 17.7163 25.593 16.9097 25.6H7.98758V7.20002H16.9097C17.1415 7.19769 17.3699 7.25559 17.5727 7.36803C18.0623 7.61509 18.3713 8.1173 18.3715 8.66641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.2,
    d: "M17.5727 8.66641V24.1304C17.5718 24.9395 16.9188 25.596 16.111 25.6H7.98758V7.20001H16.1109C16.9187 7.20044 17.5731 7.85663 17.5727 8.66562C17.5727 8.66588 17.5727 8.66614 17.5727 8.66641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1.46412 7.20001H16.1086C16.9172 7.20001 17.5727 7.85655 17.5727 8.66641V23.3336C17.5727 24.1435 16.9172 24.8 16.1086 24.8H1.46412C0.655501 24.8 0 24.1434 0 23.3336V8.66641C0 7.85655 0.65552 7.20001 1.46412 7.20001Z",
    fill: "url(#paint1_linear_44_213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M4.5761 13.3504C4.93696 12.5804 5.51942 11.936 6.24871 11.5C7.05635 11.0369 7.97592 10.806 8.90619 10.8328C9.76838 10.814 10.6191 11.033 11.3656 11.4656C12.0674 11.8847 12.6326 12.4989 12.9926 13.2336C13.3847 14.0431 13.5802 14.934 13.563 15.8336C13.582 16.7737 13.3809 17.7052 12.9759 18.5536C12.6072 19.3145 12.0241 19.9505 11.2985 20.3832C10.5233 20.829 9.64092 21.0537 8.74723 21.0328C7.86662 21.054 6.9971 20.8327 6.23353 20.3928C5.52566 19.973 4.95335 19.3582 4.5849 18.6215C4.19046 17.8237 3.99272 16.9429 4.0082 16.0528C3.99176 15.1206 4.1859 14.1968 4.5761 13.3504ZM6.35893 17.6944C6.55133 18.1812 6.87759 18.6034 7.29986 18.912C7.72997 19.213 8.245 19.3684 8.76957 19.3552C9.32823 19.3773 9.8789 19.2167 10.3383 18.8976C10.7553 18.5899 11.073 18.1666 11.2521 17.68C11.4524 17.1365 11.5512 16.5608 11.5437 15.9816C11.5499 15.3968 11.4569 14.8152 11.2689 14.2616C11.1028 13.7617 10.7953 13.3209 10.3839 12.9928C9.93594 12.6586 9.38675 12.4891 8.82868 12.5128C8.29274 12.4989 7.76618 12.6554 7.32462 12.96C6.89521 13.2699 6.56275 13.6958 6.36611 14.188C5.92991 15.3161 5.92764 16.5663 6.35972 17.696L6.35893 17.6944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M25.5603 4.79999H32.7491V12H25.5603V4.79999Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_213",
    x1: 21.1671,
    y1: 16.8,
    x2: 21.1671,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_213",
    x1: 3.05273,
    y1: 6.0542,
    x2: 14.5467,
    y2: 25.9304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.3467,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.20910a78f24c8f53c735a0877c43519f.svg";
export { ForwardRef as ReactComponent };